import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from '@angular/router';
import { ComponentsModule } from 'app/common/components/components.module';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { ArchwizardModule } from 'angular-archwizard';
import { UserProfilePage } from './user-profile-page/user-profile.page';
import { PipeModule } from 'app/pipes/pipe.module';
import { UnauthorizedModule } from '../unautorized-page/unautorized.module';
import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthGuardWithForcedLogin } from 'app/auth-core/auth-guard-with-forced-login.service';
import { MyRecipesPage } from './my-recipes/my-recipes.page';
import { MyMealPlanPage } from './my-meal-plan/my-meal-plan.page';
import { SwitchDataAnalisysModule } from '../switch-data-analisys/switch-data-analisys.module';
import { MealPlanItemComponent } from './components/meal-item/meal-item.component';
import { SwitchRecipesPage } from './switch-recipes/switch-recipes.page';
import { EditMyRecipePage } from './my-recipes/edit-recipe/edit-my-recipe.page';
import { EditSwitchRecipePage } from './switch-recipes/edit-switch-recipe/edit-switch-recipe.page';
import { MyMealPlanListPage } from './my-meal-plan/meal-plan-list.page';



export const UserProfileRoutes: Routes = [
    { path: 'user-profile', component: UserProfilePage, canActivate: [AuthGuardWithForcedLogin]},
    { path: 'recipes', component: MyRecipesPage, canActivate: [AuthGuardWithForcedLogin]},
    { path: 'recipes/my-recipe/:recipeId', component: EditMyRecipePage, canActivate: [AuthGuardWithForcedLogin]},
    { path: 'recipes/my-recipe', component: EditMyRecipePage, canActivate: [AuthGuardWithForcedLogin]},
    { path: 'recipes/switch-recipe/:recipeId', component: EditSwitchRecipePage, canActivate: [AuthGuardWithForcedLogin]},
    { path: 'recipes/switch-recipe', component: EditSwitchRecipePage, canActivate: [AuthGuardWithForcedLogin]},
	
	
    { path: 'meal-plan', component: MyMealPlanListPage, canActivate: [AuthGuardWithForcedLogin]},
    { path: 'meal-plan/plan', component: MyMealPlanPage, canActivate: [AuthGuardWithForcedLogin]},
    { path: 'meal-plan/plan/:planId', component: MyMealPlanPage, canActivate: [AuthGuardWithForcedLogin]},
	{ path: 'switch-recipes', component: SwitchRecipesPage, canActivate: [AuthGuardWithForcedLogin] }
    
];


@NgModule({
    imports: [
        CommonModule,
        ComponentsModule,
        RouterModule.forChild(UserProfileRoutes),
		NgJsonEditorModule,
		ArchwizardModule,
		UnauthorizedModule,
		PipeModule,
		NgbModule,
		SwitchDataAnalisysModule,
		NgbDropdownModule,
	
    ],
    exports: [
	],
    declarations: [
		UserProfilePage,
		MyMealPlanPage,
		MyRecipesPage,
		SwitchRecipesPage,
		MealPlanItemComponent,
		EditMyRecipePage,
		EditSwitchRecipePage,
		MyMealPlanListPage
    ],
    providers: [],
	entryComponents: [
		MealPlanItemComponent
	]
})
export class UserProfileModule { }
